import { DatetimeUtils } from '@/utils/datetime'
import { FLO } from '@/utils/flo'
import useragent from '@/utils/userAgent'
import axios from 'axios'
import dayjs from 'dayjs'
import connectSessionIdLogger from './connect-session-id/connectSessionIdLogger'
import { memberStore } from '@/store/member.store'
import { getArtistLastPage } from '@/utils/artist-pathname'

const isProduction = process.env.ENVIRONMENT === 'prod'

const ACTION_LOG_HOST = {
  STAGE: 'https://ingestion.qa.log.infra.music-flo.io',
  PRODUCTION: 'https://ingestion.log.infra.music-flo.io',
}
const ACTION_LOG_TOKEN = {
  STAGE: 'e9d0fa4ae33728e5de74c6a9f6e640302f7d23b0',
  PRODUCTION: 'a86c43e19ca7db5d98289ad7c9045e6222afdc3a',
}

const logger = axios.create()

const actionLogHost = isProduction ? ACTION_LOG_HOST.PRODUCTION : ACTION_LOG_HOST.STAGE
const actionLogToken = isProduction ? ACTION_LOG_TOKEN.PRODUCTION : ACTION_LOG_TOKEN.STAGE
const isMobile = () => /Android|iPhone/i.test(navigator.userAgent)

interface IActionLogParam {
  pageId?: string
  categoryId?: string
  actionId?: string
  memberNo?: number
  characterNo?: number
  eventName?: string
  body?: Record<string, unknown>
}
/**
 * Log Pipeline Action Log
 */
export const sendActionLog = async ({ pageId, categoryId, actionId, eventName, body = {} }: IActionLogParam) => {
  try {
    const ts = DatetimeUtils.YMDhmsMS()
    const deviceId = await FLO.UTILS.getDeviceId()
    const accessToken = ''

    await useragent.init()

    const payload = [
      {
        base_time: ts,
        local_time: ts,
        log_lib_version: isMobile() ? 'web-m-FLO_MWEB' : 'web-FLO_WEB',
        os_name: useragent.osName,
        os_version: useragent.osVersion,
        resolution: `${screen.width}*${screen.height}`,
        screen_width: screen.width,
        screen_height: screen.height,
        language_code: navigator.language,
        token: actionLogToken,
        device_id: deviceId,
        browser_name: `${useragent.browserName}`,
        browser_version: useragent.browserVersion,
        referrer: document.referrer,
        url: location.href,
        document_title: document.title,
        access_token: accessToken || '',
        page_id: `${pageId}_${getArtistLastPage()}` || window.location.pathname,
        category_id: categoryId,
        action_id: actionId,
        event_name: eventName,
        member_no: `${memberStore.getState().memberNo || ''}`,
        ...connectSessionIdLogger.getActionLogCsIdObject(),
        body: {
          ...body,
        },
      },
    ]

    await logger.post(`${actionLogHost}/v1/action_log`, payload)

    console.log(`-------------${dayjs().format('HH시 mm분 ss초')}----------------`)
    console.count()
    console.log(
      `%c :::action-log category: ${categoryId || ''} action: ${actionId || ''} page: ${pageId}
    body: ${JSON.stringify(body, null, 2)}`,
      'background: black;color:white;',
    )
  } catch (error) {
    console.error('sendActionLog error', error)
  }
}
